import React from 'react';

const TrendsPage = React.lazy(() => import('pages/trends'));
const TrendsDetailsProductGroup = React.lazy(() => import('pages/trends/details'));
const GeneratePOsPage = React.lazy(() => import('pages/trends/generate-pos'));

const policies = [{ resource: 'trends', action: 'view' }];

export const definitions = [
  {
    index: true,
    policies: policies,
    component: <TrendsPage />
  },
  {
    path: 'product-group-details/:id',
    policies: policies,
    component: <TrendsDetailsProductGroup />
  },
  {
    path: 'generate-pos',
    policies: policies,
    component: <GeneratePOsPage />
  }
];
